import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LanguageService } from 'src/app/Core/services/language.service';

@Component({
  selector: 'app-instructions',
  templateUrl: './instructions.component.html',
  styleUrls: ['./instructions.component.scss'],
})
export class InstructionsComponent {
  @Input() instruction!: string;
  @Input() loading: boolean = false;
  @Input() icon!: string;
  @Input() index!: number;
  @Input() page_sayen!: string;
  @Input() completed: boolean = false;
  @Input() showLogo: boolean = false;
  @Input() prevCompleted: boolean = false;
  @Input() background: boolean = true;
  @Output() clicked: EventEmitter<void> = new EventEmitter();
  constructor(private languageService: LanguageService) { }

  get isLeft() {
    return this.languageService.CurrentLang.IsLeft;
  }

  checkSayenPage(){
    if(this.page_sayen === 'sayen') { this.iconClickedEvent() }
  }

  iconClickedEvent(event_icon?: MouseEvent) {
    if (event_icon) {
      const targetElement = event_icon.target as HTMLElement;

      // debugger;
      if (
        targetElement.classList.contains('completed') ||
        targetElement.classList.contains('prevCompleted') ||
        targetElement.classList.contains('first')
      ) {
        this.clicked.emit();
      } else {
        //console.log('line 34 > ' + targetElement.classList);
        return ;
      }
    }

  }
}
